import { Component, OnInit, Input } from '@angular/core';

import { Pod } from 'app/shared/services/app/content/models';

@Component({
  selector: 'tog-pod-preview',
  templateUrl: 'pod-preview.component.html',
  styleUrls: ['pod-preview.component.scss']
})
export class PodPreviewComponent implements OnInit {
  @Input() visiblePods: Pod[] = [];
  @Input() navPreview: boolean = false;
  @Input() color: string;

  constructor() { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/pod-preview/pod-preview.component.ts